<div class="d-flex justify-content-between">
  <h1>{{"navigation.orders" | translate}}</h1>
  <div style="display: inline-flex;">
    <label class="hint">{{hintMessage | translate}}</label>
    <div matTooltipPosition="above">
      <button mat-flat-button [disabled]="!isReturn(selectedRows)" (click)="navigateReturn()" color="primary"
              class="action-button">{{"home.orders.return" | translate}}</button>
    </div>
    <div matTooltipPosition="above"
         [matTooltip]="(!isCopySelectedItems(selectedRows)) ? ('home.orders.tooltips.activate' | translate) : null">
      <button mat-flat-button [disabled]="!isCopySelectedItems(selectedRows)" (click)="copyFinalLens()" color="primary"
              class="action-button">{{'home.orders.copyFinalLens' | translate}}</button>
    </div>
    <div matTooltipPosition="above"
         [matTooltip]="(!isCopySelectedItems(selectedRows)) ? ('home.orders.tooltips.activate' | translate) : null">
      <button mat-flat-button [disabled]="!isCopySelectedItems(selectedRows, true)" (click)="copyTrialLens()"
              color="primary" class="action-button">{{'home.orders.copyTrialLens' | translate}}</button>
    </div>
    <div matTooltipPosition="above"
         [matTooltip]="(selectedRows.length <= 0) ? ('home.orders.tooltips.activate' | translate) : null">
      <button mat-flat-button [disabled]="selectedRows.length <= 0" (click)="print()" color="primary"
              class="action-button">{{'home.orders.print' | translate}}</button>
    </div>
    <app-new-order-picker></app-new-order-picker>
  </div>
</div>

<div class="search-panel">
  <form [formGroup]="searchForm">
    <mat-form-field color="standart" [ngClass]="(!isEnglish()) ? 'input-form-field-de' : 'input-form-field-en'">
      <input matInput formControlName="deliveryNmr" (keydown.enter)="search($event)"
             [placeholder]="'home.orders.deliveryNmr' | translate">
    </mat-form-field>
    <mat-form-field color="standart" [ngClass]="(!isEnglish()) ? 'input-form-field-de' : 'input-form-field-en'">
      <input matInput formControlName="commission" (keydown.enter)="search($event)"
             [placeholder]="'home.orders.commission' | translate">
    </mat-form-field>
    <mat-form-field color="standart"
                    [ngClass]="(!isEnglish()) ? 'input-form-field-wide-de' : 'input-form-field-wide-en'"
                    style="margin-right: 15px">
      <input formControlName="chargeNum" matInput (keydown.enter)="search($event)"
             [placeholder]="'home.orders.chargeNumMulti' | translate">
    </mat-form-field>
    <mat-form-field color="standart" class="datepicker-form-field">
      <mat-label>{{"home.orders.dateFrom" | translate}}</mat-label>
      <input matInput [matDatepicker]="df" (keydown.enter)="search($event)" formControlName="dateFrom">
      <mat-datepicker-toggle matSuffix [for]="df"></mat-datepicker-toggle>
      <mat-datepicker #df></mat-datepicker>
    </mat-form-field>
    <mat-form-field color="standart" class="datepicker-form-field">
      <mat-label>{{"home.orders.dateTo" | translate}}</mat-label>
      <input matInput [matDatepicker]="dt" (keydown.enter)="search($event)" formControlName="dateTo">
      <mat-datepicker-toggle matSuffix [for]="dt"></mat-datepicker-toggle>
      <mat-datepicker #dt></mat-datepicker>
    </mat-form-field>
    <button mat-flat-button color="primary" class="action-button"
            (click)="pickLastNMonths(2)">{{'home.orders.last2Months' | translate}}</button>
    <!--<button mat-flat-button color="primary" class="action-button" (click)="pickLastNMonths(3)">{{'home.orders.last3Months' | translate}}</button>-->
    <app-search-button (click)="search($event)"></app-search-button>
  </form>
</div>

<div class="order-table">
  <table mat-table [dataSource]="items" matSort class="table-overview">

    <ng-container matColumnDef="checkbox">
      <th mat-header-cell *matHeaderCellDef
          class="header-check">{{"home.orders.actions" | translate}}</th>
      <td mat-cell *matCellDef="let row"
          class="cell-check">
        <mat-checkbox (change)="select(row)" class="checkbox" [checked]="isNeedCheck(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="orderDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header
          class="header-date">{{"home.orders.orderDate" | translate}}</th>
      <td mat-cell *matCellDef="let row">{{getOrderDate(row.orderDate)}}</td>
    </ng-container>

    <ng-container matColumnDef="side">
      <th mat-header-cell *matHeaderCellDef mat-sort-header
          class="header-side">{{"home.orders.side" | translate}}</th>
      <td mat-cell *matCellDef="let row"
          class="cell-side">{{getSide(row)}}</td>
    </ng-container>

    <ng-container matColumnDef="count">
      <th mat-header-cell *matHeaderCellDef mat-sort-header
          class="header-quantity">{{"home.orders.count" | translate}}</th>
      <td mat-cell *matCellDef="let row"
          class="cell-quantity">{{row.count}}</td>
    </ng-container>

    <ng-container matColumnDef="article">
      <th mat-header-cell *matHeaderCellDef mat-sort-header
          class="header-article">{{"home.orders.article" | translate}}</th>
      <td mat-cell *matCellDef="let row"
          class="cell-article"><span style="white-space: pre-line">{{getArticle(row)}}</span></td>
    </ng-container>

    <ng-container matColumnDef="commission">
      <th mat-header-cell *matHeaderCellDef mat-sort-header
          class="header-commission">{{"home.orders.commission" | translate}}</th>
      <td mat-cell *matCellDef="let row"
          class="cell-commission">{{row.commission}}</td>
    </ng-container>

    <ng-container matColumnDef="chargeNum">
      <th mat-header-cell *matHeaderCellDef
          class="header-lot">{{"home.orders.chargeNum" | translate}}</th>
      <td mat-cell *matCellDef="let row">{{row.chargeNumber}}</td>
    </ng-container>

    <ng-container matColumnDef="return">
      <th mat-header-cell *matHeaderCellDef
          class="header-return">{{"home.orders.return" | translate}}</th>
      <td mat-cell *matCellDef="let row"
          class="cell-return">
        <div *ngIf="row.credit !== null">
          <div class="credit"
               matTooltipPosition="above"
               [matTooltip]="row.credit ? getCreditRow(row) : 'home.orders.tooltips.withReturn' | translate">
            GS
          </div>
        </div>
        <div *ngIf="row.credit == null">
          <div *ngIf="row.isReturn">
            <img src="assets/img/icons/revert.svg" matTooltipPosition="above"
                 [matTooltip]="row.credit ? getCreditRow(row) : 'home.orders.tooltips.withReturn' | translate">
          </div>
          <div *ngIf="!row.isReturn">
            <img src="assets/img/icons/revert-cross.svg" matTooltipPosition="above"
                 [matTooltip]="row.credit ? getCreditRow(row) : 'home.orders.tooltips.withoutReturn' | translate">
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef
          class="header-status">{{"home.orders.status" | translate}}</th>
      <td mat-cell *matCellDef="let row"
          class="cell-status">
        <div *ngIf="row.orderStatus === OrderStatus.DRAFT">
          <img src="assets/img/icons/draft.svg" [matTooltip]="'home.orders.tooltips.draft' | translate"
               matTooltipPosition="above">
        </div>
        <div *ngIf="row.orderStatus === OrderStatus.SENT">
          <img src="assets/img/icons/send.svg" [matTooltip]="'home.orders.tooltips.sent' | translate"
               matTooltipPosition="above">
        </div>
        <div *ngIf="row.orderStatus === OrderStatus.SYNCED && row.itemStatus === OrderItemStatus.RETURNED">
          <img src="assets/img/icons/backward.svg" [matTooltip]="'home.orders.tooltips.returned' | translate"
               matTooltipPosition="above">
        </div>
        <div *ngIf="row.orderStatus === OrderStatus.SYNCED && row.itemStatus === OrderItemStatus.ORDER_ENTRY">
          <img src="assets/img/icons/checking.svg" [matTooltip]="'home.orders.tooltips.entry' | translate"
               matTooltipPosition="above">
        </div>
        <div *ngIf="row.orderStatus === OrderStatus.SYNCED && row.itemStatus === OrderItemStatus.PRODUCTION">
          <img src="assets/img/icons/factory.svg" [matTooltip]="'home.orders.tooltips.prod' | translate"
               matTooltipPosition="above">
        </div>
        <div *ngIf="row.orderStatus === OrderStatus.SYNCED && row.itemStatus === OrderItemStatus.PREPARATION">
          <img src="assets/img/icons/packing.svg" [matTooltip]="'home.orders.tooltips.prepare' | translate"
               matTooltipPosition="above">
        </div>
        <div *ngIf="row.orderStatus === OrderStatus.SYNCED && row.itemStatus === OrderItemStatus.DELIVERY">
          <img src="assets/img/icons/container-truck.svg" [matTooltip]="getDeliveryTooltip(row)"
               matTooltipClass="info-tooltip" matTooltipPosition="above">
        </div>
        <div *ngIf="row.orderStatus === OrderStatus.SYNCED && row.itemStatus === OrderItemStatus.STORNO">
          <img src="assets/img/icons/delete.svg" [matTooltip]="'home.orders.tooltips.storno' | translate"
               matTooltipPosition="above">
        </div>
        <div *ngIf="row.orderStatus === OrderStatus.SYNCED && row.itemStatus === OrderItemStatus.ERROR">
          <img src="assets/img/icons/comments.svg" [matTooltip]="'home.orders.tooltips.error' | translate"
               matTooltipPosition="above">
        </div>
        <div *ngIf="row.orderStatus === OrderStatus.SYNCED && row.itemStatus === OrderItemStatus.INVOICE">
          <img src="assets/img/icons/purchase-order.svg" [matTooltip]="getInvoiceTooltip(row)"
               matTooltipClass="info-tooltip" matTooltipPosition="above">
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef
          class="header-info">{{"newOrder.equipment.columnNames.info" | translate}}</th>
      <td mat-cell *matCellDef="let row"
          class="cell-info">
        <div class="d-flex">
          <img src="assets/img/icons/info.svg" style="cursor: pointer;" (click)="openInfoDialog(row)"
               matTooltipPosition="above">
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-card *ngIf="isLoading" class="spinner-wrapper">
    <mat-progress-spinner class="spinner" color="primary" mode="indeterminate"></mat-progress-spinner>
  </mat-card>

  <div class="table-overlay">
    {{"home.orders.productionTimes" | translate}}
    <a href="https://hecht-contactlinsen.de/wp-content/uploads/Fertigungszeiten_extern.pdf">
      {{"home.orders.productionTimesLink" | translate}}
    </a>
  </div>

  <mat-paginator [pageSizeOptions]="[5, 7, 10]" showFirstLastButtons color="standart" class="paginator-overview"
                 #overviewPaginator="matPaginator"></mat-paginator>
</div>
